import { type FC } from 'react';

import { prefixImageUrl } from '../../utils/helpers';

interface ICategoryIconImage {
  name: string;
  visible: boolean;
  url: string;
  onError: VoidFunction;
}

const CategoryIconImage: FC<ICategoryIconImage> = ({ name, visible, url, onError }) => {
  return (
    <img
      alt={`${name} icon`}
      className={`games__title-icon ${!visible ? 'hidden' : ''}`}
      src={prefixImageUrl(url)}
      onError={() => onError()}
    />
  );
};

export default CategoryIconImage;
